// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import devtools from '@vue/devtools';
// if (process.env.NODE_ENV === 'development') {
//   devtools.connect('//localhost', '8098');
// }

import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import axios from 'axios';
import util from '@/utils/util.js';
import VTree from '@/lib/vTree/index.js';
import api from '@/api';
// import femonitorVue from 'femonitor-vue';
import { setInterval, clearInterval, setTimeout } from 'timers';
// femonitorVue(Vue);


/* if(window.feMonitor){
  try{
    feMonitor.setConfig({
      // slientDev: false, //开发环境是否发送报错请求，默认不发送
      sampleRate:1, //采样率,可设置0-1之间，越小采集的频率越低，默认为0.3，即采集30%,收费项目建议都设置成1
      isCollectPerformance:true, //采集性能，默认为false
      isCollectError: false//是否采集错误
    });
  } catch(e){}
} */
// import echarts from 'echarts';
// window.echarts = echarts;
// require('echarts/lib/chart/bar');
// require('echarts/lib/chart/line');
// require('echarts/lib/component/tooltip');
// require('echarts/lib/chart/heatmap');
// require('echarts/lib/component/visualMap');
// require('echarts/lib/component/visualMapContinuous');
// require('echarts/lib/component/visualMapPiecewise');
// require('echarts/lib/component/dataZoom');
// require('echarts/lib/chart/pie');
// require('echarts/lib/chart/scatter');
// require('echarts/lib/chart/graph');
// require('echarts/lib/component/axisPointer');
// require('echarts/lib/chart/candlestick');
// require('echarts/lib/component/legendScroll');
// require('echarts/lib/component/graphic');
// require('echarts/lib/component/grid');
// require('echarts/lib/component/singleAxis');
// require('echarts/lib/component/title');

Vue.use(VTree);

// ah.hookAjax({
//   //hook callbacks
//   onreadystatechange: function(xhr) {
//     // console.info('onreadystatechange called: %O', xhr);
//   },
//   onload: function(xhr) {
//     // console.info('onload called: %O', xhr);
//   },
//   //hook function
//   open: function(arg, xhr) {
//     console.info('open called: method:%s,url:%s,async:%s', arg[0], arg[1], arg[2], xhr);
//     arg[1] = '//proxy://////' + arg[1];
//   }
// });
window.dynamicDomain = window.Acme.getDomain();
// weblog注册
window.weblog.setConfig({ appKey: '280cb4f33f' });

Vue.config.productionTip = false;
window.eventBus = new Vue();
Vue.prototype.$eventBus = new Vue();

Vue.prototype.$http = axios;
Vue.prototype.$api = api;
window.$util = util;
window.$onshow = true;
Vue.prototype.$util = util;
util.resize(function () {
  const clientWidth = document.body.scrollWidth;
  document.body.style.width = `${clientWidth  }px`;
});
API.use({
  method: 'Util.getSkinName',
  success (theme) {
    if (theme == '白色风格' && window.clientType !== 2) {
      document.getElementsByTagName('html')[0].className += ' white';
      window.theme = 'white';
    } else {
      window.theme = 'black';
    }
  },
  notClient: () => {
    window.theme = 'black';
  },
  error () { }
});
checkClientProduct();

/**
 * window.clientType 客户端类型判断，0-免费页面，1-level2页面，2-金融大师页面
 */
function checkClientProduct() {
  window.clientType = 0;
  API.use({
    method: 'Util.getHxProduct',
    success: res => {
      if (Number(res) === 6 || Number(res) === 1 || Number(res) === 2) {
        //金融大师客户端，大研究客户端,财富先锋客户端
        if (res == 6) {
          TA.log({ id: 'L2rdzz_client_jrds' });
        } else if (res == 1) {
          TA.log({ id: 'L2rdzz_client_dyj' });
        } else if (res == 2) {
          TA.log({ id: 'L2rdzz_client_cfxf' });
        }
        window.clientType = 2;
        window.jrdsType = res;
        window.theme = 'black';
        $('html').removeClass('white');
        openVue();
      } else if (Number(res) === 0) {
        //免费客户端
        API.use({
          method: 'Passport.isLevel2User',
          success: isLevel2User => {

            // 统一版客户端返回布尔值，ifind客户端返回字符'true'或'false',兼容处理
            if (Number(isLevel2User) || isLevel2User == 'true') {
              //Level2用户
              window.clientType = 1;
            }
            openVue();
          }
        });
      } else {
        window.clientType = 1;
        openVue();
      }
    },
    notClient: () => {
      window.clientType = 2;
      openVue();
    },
    error: () => { }
  });
}

/**
 *
 */

/* eslint-disable no-new */
function openVue() {
  new Vue({
    el: '#app',
    router,
    store,
    // components: { App },
    // template: '<App/>'
    render: h => h(App)
  });
}



// WEBPACK FOOTER //
// ./src/main.js